import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

import { SkeletonMainDestopComponent } from './skeleton-main-desktop.component';
import { SkeletonMainMobileComponent } from './skeleton-main-mobile.component';
import { SkeletonPage } from './skeleton-page.model';

@Component({
    selector: 'ms-skeleton-sports-base',
    templateUrl: './skeleton-sports-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SkeletonMainMobileComponent, SkeletonMainDestopComponent],
})
export class SkeletonSportsBaseComponent {
    device = inject(DeviceService);

    @Input() pageName: SkeletonPage;
    @HostBinding('class') className = 'sk-sports-skeleton-base bg-schedule-skeleton';
}
